import { Text } from '@mantine/core';
import AuthLink from './AuthLink';

const AuthTermsDisclaimer = () => {
  return (
    <Text size='sm' c='dimmed' ta='center'>
      By continuing, you are indicating that you accept our{' '}
      <AuthLink to=''>Terms of Service</AuthLink> and{' '}
      <AuthLink to=''>Privacy Policy</AuthLink>.
    </Text>
  );
};

export default AuthTermsDisclaimer;
